import { defineMessages } from 'react-intl';

const _default_1: {
	logoAltText: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	logoText: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	betaLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	cancelLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	discardLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	defaultInputPlaceholder: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	defaultRovoInputPlaceholder: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	placeholderWithAgent: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	disclaimer: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	disclaimerLink: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	previewScreenLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	refineButton: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	highlightDifferencesLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	highlightDifferencesDisabledTooltip: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	actionButtonsAccessibleLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	actionButtonsTryAgain: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	actionButtonsAccept: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	logoAltText: {
		id: 'fabric.editor.ai.screens.prompt.logoAltText',
		defaultMessage: 'Atlassian Intelligence Logo',
		description: 'Atlassian Intelligence logo alt text of the Prompt screen',
	},
	logoText: {
		id: 'fabric.editor.ai.screens.prompt.logoText',
		defaultMessage: 'Atlassian Intelligence',
		description: 'Atlassian Intelligence Logo text of the Prompt screen',
	},
	betaLabel: {
		id: 'fabric.editor.ai.screens.preview.betaLabel',
		defaultMessage: 'Beta',
		description: 'The label describing the beta status of the Atlassian Intelligence feature',
	},
	cancelLabel: {
		id: 'fabric.editor.ai.screens.preview.cancelLabel',
		defaultMessage: 'Cancel',
		description: 'The action text for the cancel button to discard the previewed generated content',
	},
	discardLabel: {
		id: 'fabric.editor.ai.screens.preview.discardLabel',
		defaultMessage: 'Discard',
		description: 'The action text for the discard button to cancel the previewed generated content',
	},
	defaultInputPlaceholder: {
		id: 'fabric.editor.ai.screens.preview.defaultAIPlaceholder',
		defaultMessage: 'Tell AI what to do next',
		description:
			'The default placeholder text for the prompt input field within the Preview screen',
	},
	defaultRovoInputPlaceholder: {
		id: 'fabric.editor.ai.screens.preview.defaultRovoInputPlaceholder',
		defaultMessage: 'Tell Rovo what to do next',
		description:
			'The default placeholder text for the prompt input field within the Preview screen',
	},
	placeholderWithAgent: {
		id: 'fabric.editor.ai.screens.preview.placeholderWithAgent',
		defaultMessage: 'Ask {agentName} what to do next',
		description:
			'The placeholder text for the prompt input field within the Preview screen when an agent is selected',
	},
	disclaimer: {
		id: 'fabric.editor.ai.screens.preview.disclaimer',
		defaultMessage: 'Information quality may vary.',
		description: 'The text for the generated content disclaimer',
	},
	disclaimerLink: {
		id: 'fabric.editor.ai.screens.preview.disclaimerLink',
		defaultMessage: 'Learn why',
		description: 'The text for the generated content disclaimer link',
	},
	previewScreenLabel: {
		id: 'fabric.editor.ai.experience.previewScreenLabel',
		defaultMessage: 'Preview',
		description: 'Accessible label for the AI response preview screen of the AI modal',
	},
	refineButton: {
		id: 'fabric.editor.ai.screens.preview.refineButton',
		defaultMessage: 'Refine',
		description: 'The action text for the refine button to edit the previewed generated content',
	},
	highlightDifferencesLabel: {
		id: 'fabric.editor.ai.screens.preview.highlightDifferencesLabel.non-final',
		defaultMessage: 'Highlight differences',
		description:
			'The label for the toggle to highlight differences between the user selection and the generated response',
	},
	highlightDifferencesDisabledTooltip: {
		id: 'fabric.editor.ai.screens.preview.highlightDifferencesDisabledTooltip.non-final',
		defaultMessage: 'This feature is not available for this AI generated response.',
		description:
			'The tooltip text when the toggle to highlight differences between the user selection and the generated response is disabled',
	},
	actionButtonsAccessibleLabel: {
		id: 'fabric.editor.ai.screens.preview.actionButtonsAccessibleLabel',
		defaultMessage: 'Actions for AI generated content',
		description: 'Accessible label for the action buttons of the AI generated content',
	},
	actionButtonsTryAgain: {
		id: 'fabric.editor.ai.screens.preview.actionButtonsTryAgain',
		defaultMessage: 'Try again',
		description:
			'Label for a button that allows the user to retry the most recent AI prompt. Shown on the AI preview screen when a previous attempt has completed or failed.',
	},
	actionButtonsAccept: {
		id: 'fabric.editor.ai.screens.preview.actionButtonsAccept',
		defaultMessage: 'Accept',
		description:
			'Label on a button in the AI-generated content preview screen. When clicked, it confirms and applies the AI-generated content to the editor.',
	},
});
export default _default_1;
